import React, {
} from 'react';

import {
    SignupOptionsComponent,
    UiSignupContainer,
} from '../../../common/UiSignup';
import { useIsLegacyForm } from '../../../util/hooks/IsLegacyForm';

const RightContainer = () => {
    const isLegacyForm = useIsLegacyForm() ;
    return (
        <UiSignupContainer
            title="GET_STARTED"
        >
            <SignupOptionsComponent useLegacyForm={isLegacyForm} />
        </UiSignupContainer>);
};

export default RightContainer;
